import { Measures } from './measures';

const { breakpoints } = Measures;

export const Devices = {
  mobileSm: `(min-width: ${breakpoints.mobileSm})`,
  mobileLg: `(min-width: ${breakpoints.mobileLg})`,
  tabletSm: `(min-width: ${breakpoints.tabletSm})`,
  tabletLg: `(min-width: ${breakpoints.tabletLg})`,
  laptop: `(min-width: ${breakpoints.laptop})`,
  desktop: `(min-width: ${breakpoints.desktop})`,
};
